export default __webpack_public_path__ + "static/media/logo.7d3a9644.webp";